import * as AuthActionTypes from './auth/actionTypes';
import * as PaymentActionTypes from './paymentRequest/actionTypes';
import * as TemplateActionTypes from './template/actionType';



export const ActionTypes = Object.assign(
  {},
  AuthActionTypes,
    PaymentActionTypes,
    TemplateActionTypes
);
